<script>
    import { fade } from 'svelte/transition';
    import { currency, balance, gameResult, gameState } from '../../../store/index';
    import { totalBet } from '@root/src/store/chips';
    

    const titleClass = 'text-[8px] text-white/80 leading-[2px]';
    const valueClass = 'font-bold text-xs';
</script>

<div class="footer items-center font-Roboto desktop:!hidden">
    <div class="bet-range py-1 text-left">
        <div class="md:-translate-y-1.5">
            <div class={titleClass}>Total bet</div>
            <div class={valueClass}>
                {$currency}
                {$totalBet}
            </div>
        </div>
    </div>

    <div class="bet text-center">
        {#if parseFloat($gameResult?.winAmount) > 0 && $gameState === 'BIG_WIN'}
            <div transition:fade|global class={titleClass}>WIN</div>
            <div class={valueClass} transition:fade|global>
                {$currency}
                {$gameResult?.winAmount}
            </div>
        {/if}
    </div>

    <div class="balance py-1 text-right">
        <div class="md:-translate-y-1.5">
            <div class={titleClass}>Balance</div>
            <div class={valueClass}>
                {$currency}
                {$balance}
            </div>
        </div>
    </div>
</div>

<style>
    .footer {
        padding-bottom: var(--safe-area-inset-bottom);
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        height: var(--footer-height);
        color: white;
        font-weight: 500;
        width: 100%;
    }
</style>
